export const  apiEnvironment = {
 // baseUrl: "https://api.technogenesis.in/api/V1/AP",
  testUrl: "https://backend.technogenesis.in"
  
  // testUrl: "http://192.168.148.187:8080"
}